import { Wrapper, TopArea, TextMiddleArea, Label } from './LoanPromoListItem.styled';
import { Subtitle, Chip, Button } from '@/components/atoms';
import { rem } from '@/styles/theme';

interface IProps {
  title?: string;
  subTitle?: string;
  interestRate?: string;
  maxPrice?: string;
  footer?: string;
  buttonLabel?: string;
  chip?: string | null;
  onClick: () => void;
}

const LoanPromoListItem = (props: IProps) => {
  const {
    title = '',
    subTitle = '',
    interestRate = '',
    maxPrice = '',
    footer = ' ',
    buttonLabel = '',
    chip = "",
    onClick,
  } = props;

  return (
    <Wrapper onClick={onClick}>
      <TopArea>
        <Subtitle level={5}>{title}</Subtitle>
        {chip && <Chip>{chip}</Chip>}
      </TopArea>
      <Subtitle level={2} color="gray-800" whiteSpaceWrap>
        {subTitle}
      </Subtitle>
      <TextMiddleArea>
        <Label>
          <Subtitle level={6}>금리</Subtitle>
          <Subtitle level={1} color="gray-800">
            {interestRate}
          </Subtitle>
        </Label>
        <Label>
          <Subtitle level={6}>최대</Subtitle>
          <Subtitle level={1} color="gray-800">
            {maxPrice}
          </Subtitle>
        </Label>
      </TextMiddleArea>
      <Subtitle level={9} color="gray-500" whiteSpaceWrap>
        {footer}
      </Subtitle>
      <Button style={{ marginTop: rem(2) }}>{buttonLabel}</Button>
    </Wrapper>
  );
};

export default LoanPromoListItem;
